import { RouteName, reverse } from 'shared/shared/routing/mixily-routes';
import { _makeAbsoluteUrl } from 'shared/shared/utils';
import config from 'config';

export const makeAbsoluteUrl = (pathName: RouteName, params?: Record<string, string>): string => {
  const path = reverse(pathName, params);
  return _makeAbsoluteUrl(config.hostname, path, config.useInsecureHttp);
};
